import { TextField, Box } from '@mui/material';
import styles from '../styles/jobSearchBar.module.scss';

export default function JobSearchBar({ query, setQuery }) {

    return (
        <Box className={styles.searchContainer}>

            <TextField
                label="Search (e.g. job title)"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className={styles.field}
                fullWidth
            />

        </Box>
    );
}